import axios from 'axios'
import { Loading } from 'element-ui'
import store from '../store'
import router from '../router'
import context from '../main.js'
let baseURL = '/api/'
if (process.env.NODE_ENV === 'production') {
  baseURL = '/yiban'
}

let loading = null
let count = 0
const showLoading = () => {
  if (count <= 0) {
    loading = Loading.service({
      lock: true,
      text: '拼命加载中',
      spinner: 'el-icon-loading',
      customClass: 'loading',
      background: 'rgba(0, 0, 0, 0.6)'
    })
  }
  count++
}
const hideLoading = () => {
  count--
  if (count <= 0 && loading) {
    loading.close()
  }
}

const service = axios.create({
  baseURL,
  timeout: 0,
  method: 'GET'
})

service.interceptors.request.use(config => {
  let token = store.state.token
  if (token) {
    config.headers.token = token
  }
  if (config.loading !== false) {
    showLoading()
  }
  return config
}, err => {
  return Promise.reject(err)
})

service.interceptors.response.use(response => {
  if (response.config.loading !== false) {
    hideLoading()
  }
  if (response.data.size) { // blob
    return response.data
  }
  if (response.data.code === 200) {
    if (response.data.ticket) { // token
      store.commit('setToken', response.data.ticket)
    }
    return response.data.data
  } else {
    if (response.data.code === 500) {
      context.$message({
        message: response.data.message,
        type: 'warning'
      })
    }
    return Promise.reject(new Error(response.data.msg))
  }
}, err => {
  if (err.response && err.response.data.code === 405) {
    context.$message({
      message: '登录凭据过期，请重新登录！',
      type: 'warning'
    })
    router.push('/login')
  }
  hideLoading()
  return Promise.reject(err)
})

export default service